import React, { FunctionComponent } from 'react';
import Style                        from './Headline.style';
import { TitleProps }               from 'antd/es/typography/Title';

type TProps = TitleProps & {
  className?: string,
  children?: React.ReactNode,
}

export const Headline: FunctionComponent<TProps> = ({ children, ...props }) => {

  return (
    <Style {...props}> {children} </Style>
  );

};
